<template>
    <g>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M42.2,37.4c-1.1,0-3.3,3.6-2.2,3.2c0.9-0.3,2.4-1.1,2.8-1.1
		c3.9,0.4,7.8,1.2,7.8,1.1c0.1-0.7-0.4-1.7-0.8-2.2C49.5,38,44.1,37.4,42.2,37.4z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M63.9,41.7c-1.8-0.5-2.8-0.4-4.6,0.8c-0.4,0.3-1,0.9-0.9,0.9
		c0.8-0.4,1.6-0.6,2.3-0.8c0,0.4,0.1,0.9,0.2,1.2h2.6c0.3-0.3,0.4-0.6,0.5-1.1c0-0.1,0-0.1,0-0.2c1.6,0.3,2.6,0.9,2.7,0.8
		C66.7,43.4,66,42.2,63.9,41.7z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M48.1,42.5c-1.7-1.2-2.7-1.3-4.5-0.8c-2,0.5-2.7,1.7-2.8,1.7
		c0.1,0,1-0.6,2.6-0.8c0,0.1,0,0.1,0,0.2c0,0.4,0.2,0.8,0.5,1.1h2.6c0.2-0.3,0.3-0.8,0.3-1.2c0.7,0.2,1.5,0.4,2.3,0.8
		C49,43.4,48.4,42.7,48.1,42.5z"/>
        <path style="fill-rule:evenodd;clip-rule:evenodd;fill:#281F1F;" d="M65.3,37.4c-1.9,0-7.4,0.6-7.7,1c-0.4,0.5-0.9,1.5-0.8,2.2
		c0,0,3.9-0.8,7.9-1.1c0.4,0,1.6,0.7,2.7,1.1C68.5,41.1,66.4,37.4,65.3,37.4z"/>
    </g>
</template>

<script>
    export default {
        name: 'Eye1',
    }
</script>
